import ReactSelect from "react-tailwindcss-select";
import "./styles.css";
import { getIn } from "formik";

const Select = ({
  options,
  formik,
  name,
  onChange,
  label,
  placeholder,
  onSearch,
  menuClassName,
  showError,
  disabled,
}) => {
  const handleSelect = (val) => {
    formik?.setFieldValue(name, val);
    formik?.setFieldTouched(name, true);

    if (onChange) {
      onChange(val);
    }
  };

  const required =
    formik &&
    Object.keys(formik?.initialValues).some((key) => key === name);

  const nestedError = getIn(formik?.errors, name);
  const nestedTouched = getIn(formik?.touched, name);

  return (
    <div className="relative mb-4">
      {label && (
        <label className="block mb-1 text-[17px] font-bold capitalize">
          {label} {required && <span className="text-mainRed">*</span>}
        </label>
      )}

      <ReactSelect
        value={formik?.values?.[name] || null}
        options={options || []}
        placeholder={placeholder}
        onSearchInputChange={onSearch}
        onChange={handleSelect}
        isDisabled={disabled}
        classNames={{
          menuButton: ({ isDisabled }) =>
            `flex text-sm text-mainGray select-menu h-[40px] px-2 border border-[#88888880] rounded shadow-sm transition-all duration-300 focus:outline-none ${
              isDisabled
                ? "bg-gray-200"
                : "bg-white hover:border-gray-400 focus:border-blue-500 focus:ring focus:ring-blue-500/20"
            } ${menuClassName || ""}`,

          listItem: ({ isSelected }) =>
            `block transition duration-200 px-2 py-2 cursor-pointer select-none truncate ${
              isSelected
                ? "text-white bg-blue-500"
                : "text-gray-500 hover:bg-blue-100 hover:text-blue-500"
            }`,

          menu:
            "absolute z-10 w-full bg-white shadow-lg border rounded mt-1.5 text-sm text-gray-700",
        }}
      />

      {(showError || !disabled) &&
        nestedError &&
        (showError || nestedTouched) && (
          <span className="text-[12px] text-mainRed absolute bottom-[-16px]">
            {nestedError}
          </span>
        )}
    </div>
  );
};

export default Select;